import * as React from "react";
import { observer, inject } from "mobx-react";
import jMoment from "moment-jalaali";
// Hooks and utilities
import showNotify from "helpers/notify";
import useWallet from "hooks/useWallet";
import useUser from "hooks/useUser";
import addCommas from "helpers/index";
import { useIssue } from "../..";
// Shared components
import Info from "screens/Dashboard/components/Info";
import Button from "components/Button";
// Local component
import UserStore from "state/user";
// Styles
import styles from "./index.module.scss";

interface IProps {
	user?: UserStore | any;
}

const SecondStep: React.FC<IProps> = (props: IProps) => {
	const { state, dispatch } = useIssue();
	const { buyGold } = useWallet();
	const { getUserInfo } = useUser();

	async function payment() {
		const amount = Number(state.unit);

		const res = await buyGold({
			amount,
			baseBaazarAmount: props.user.goldBuyPrice,
		});

		switch (res.status) {
			case "DONE":
				// decrease balance and increase asset amount
				getUserInfo();
				// go to next step
				dispatch({ current: 2 });
				showNotify({
					text: "خرید با موفقیت انجام شد.",
				});
				break;
			case "PRICE_CHANGED":
				showNotify({
					text: "قیمت دارایی مورد نظر تغییر کرده است. مجددا سعی کنید.",
				});
				break;
			case "FAIL":
				showNotify({
					text: "خطایی رخ داده است. مجددا سعی کنید.",
				});
				break;
		}
	}
	function previous() {
		dispatch({ current: 0 });
	}

	return (
		<div className={styles["main"]}>
			<h3 className={styles["main__title"]}>اطلاعات درخواست خرید طلا</h3>
			<div className={styles["main__table"]}>
				<Info prefix="طلا" title="مقدار گرم طلای درخواستی" info={state.unit} />
				<Info
					prefix="ریال"
					title="مبلغ قابل دریافت"
					info={addCommas(Math.round(state.unit * props.user.goldBuyPrice))}
				/>
				<Info title="تاریخ درخواست" info={jMoment().format("jYYYY/jMM/jDD")} />
				<Info title="قیمت خرید هر گرم طلا در سامانه" prefix="ریال" info={addCommas(props.user.goldBuyPrice)} />
			</div>
			<div className="button-center">
				<Button onClick={previous} primary>
					بازگشت
				</Button>
				<Button onClick={payment} green>
					پرداخت
				</Button>
			</div>
		</div>
	);
};

export default inject("user")(observer(SecondStep));
